import { render, staticRenderFns } from "./dangerJournalResult.vue?vue&type=template&id=4eda4a30"
import script from "./dangerJournalResult.vue?vue&type=script&lang=js"
export * from "./dangerJournalResult.vue?vue&type=script&lang=js"
import style0 from "./dangerJournalResult.vue?vue&type=style&index=0&id=4eda4a30&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eda4a30')) {
      api.createRecord('4eda4a30', component.options)
    } else {
      api.reload('4eda4a30', component.options)
    }
    module.hot.accept("./dangerJournalResult.vue?vue&type=template&id=4eda4a30", function () {
      api.rerender('4eda4a30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerJournalResult.vue"
export default component.exports